import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { CardSkeleton } from "components/Skeleton";
import { adjustmentRequest } from "utils/adjustmentNoteAPI";
import DebitNoteEditor from "../DebitNote/DebitNoteEditor";
import LegacyCreditEditor from "./AddCreditNote";
// Existing standalone credits retain their original editing contract. New
// linked credits use the designer's invoice-adjustment journey.
import "./creditDesign.css";
export default function AdjustmentCreditEditor() {
  const { id } = useParams();
  const [retry, setRetry] = useState(0);
  const [legacy, setLegacy] = useState(null),
    [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setLegacy(null);
    setError("");
    if (id)
      adjustmentRequest("credit", `/${id}`, undefined, "get")
        .then(({ note }) => {
          if (active) setLegacy(!note.sourceInvoiceID);
        })
        .catch((e) => {
          if (active) setError(e.response?.data?.Result_Message || e.message);
        });
    return () => {
      active = false;
    };
  }, [id, retry]);
  if (!id) return <DebitNoteEditor credit />;
  if (error || legacy === null) return (
    <DashboardLayout>
      <DashboardNavbar />
      <main className="debit-page credit-editor-page app-register-page-content">
        <Link to="/creditNote">Credit notes</Link>
        <h1>Edit credit note</h1>
        {error ? (
          <section className="credit-load-error" role="alert">
            <h2>Credit note could not be loaded</h2>
            <p>{error}</p>
            <button type="button" className="debit-secondary-button" onClick={() => setRetry((current) => current + 1)}>Retry</button>
          </section>
        ) : <CardSkeleton />}
      </main>
    </DashboardLayout>
  );
  return legacy ? <LegacyCreditEditor /> : <DebitNoteEditor credit />;
}
